import React from "react";
import { formatTime } from "src/utils/breakReason";

import { Box, MenuItem, Tooltip } from "@mui/material";

import { Separator, TimeDisplay } from "./styles";

import PauseCircleOutlineIcon from '@mui/icons-material/PauseCircleOutline';


const BreakReasonTimerSimple = ({
	status,
	elapsedTime,
	breaklimit,
	handleOpenEndBreakDialog,
	intl,
	disableTimeout,
}) => {

	return (
		<MenuItem key={1}>
			<Tooltip title={intl.formatMessage({ id: "break.reason.time.end" })} arrow>
				<Box
					sx={{
						flex: 1,
						display: 'flex',
						alignItems: 'center',
						gap: '8px',
						cursor: 'pointer'
					}}
					onClick={handleOpenEndBreakDialog}
				>
					<PauseCircleOutlineIcon />

					<TimeDisplay status={status} simple={true}>
						{formatTime(elapsedTime)}

						{!disableTimeout && (
							<React.Fragment>
								<Separator status={status} simple={true}>/</Separator>

								<span style={{ opacity: 0.7 }}>{breaklimit}</span>
							</React.Fragment>
						)}
					</TimeDisplay>
				</Box>
			</Tooltip>
		</MenuItem>
	)
};

export default BreakReasonTimerSimple;